import { Alert } from '@/react/components/core-ui/Alert';
import { useTimedMemo } from '@/react/hooks/useTimedMemo';
import { memo, useCallback } from 'react';

export interface IPastPreviewAlertProps {
  /**
   * The current preview date as a timestamp,
   * or `null` if no preview is active.
   */
  preview: number | null;
}

export const PastPreviewAlert = memo(function PastPreviewAlert({
  preview
}: IPastPreviewAlertProps) {
  const isPreviewPastCallback = useCallback(() => {
    if (preview === null) return false;
    return preview < Date.now();
  }, [preview]);

  // check if the preview value is in the past every minute
  const isPreviewPast = useTimedMemo(isPreviewPastCallback, 'minute');

  if (!isPreviewPast) return null;

  return (
    <Alert
      variant="warning"
      style={{ marginBottom: 0 }}
      wrapperStyles={{ fontSize: 13, padding: 10 }}
    >
      The current preview date is in the past. Some preview features may not
      work as expected.
    </Alert>
  );
});
